import { CSSProperties } from 'react';
import { Cell, flexRender } from '@tanstack/react-table';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Order } from '@/types/api';

interface DragAlongCellProps {
  cell: Cell<any, unknown>; // TanStack Table Cell 타입
  disableDrag?: boolean;
  checkedOrders?: Order[];
  order?: Order; // 현재 셀에 해당하는 주문 정보
}

export const DragAlongCell = ({
  cell,
  order,
  disableDrag = false,
  checkedOrders,
}: DragAlongCellProps) => {
  const { setNodeRef, transform, isDragging } = useSortable({
    id: cell.column.id,
    disabled: disableDrag,
  });

  const isCheckbox = cell.column.id === 'checkbox';
  function deepEqual(a: any, b: any): boolean {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  const isChecked = checkedOrders?.some((o) => deepEqual(o, order)) ?? false;

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: isCheckbox ? 'sticky' : 'relative',
    left: isCheckbox ? 0 : 'auto',
    transform: CSS.Translate.toString(transform),
    transition: 'width transform 0.2s',
    maxHeight: '60px',
    width: cell.column.getSize(),
    zIndex: isCheckbox ? 20 : isDragging ? 1 : 0,
    background: isChecked
      ? '#F2F0FF' // 체크된 경우 파란색 배경
      : isCheckbox
      ? 'inherit' // ⭐ 반드시 inherit로!
      : isDragging
      ? '#F2F0FF' // 드래그 중 배경
      : 'transparent',
  };

  return (
    <td ref={setNodeRef} style={style} className="h-[60px] max-h-[60px] Body5M14">
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};
